<template>
	<div class="comments">
		<back-to></back-to>
		<van-list class="visadetail-Rate" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
			:immediate-check="false">
			<ul>
				<li v-for="(item, index) in data_product_array" :key="index">
					<div class="visadetail-Ratet">
						<span class="visadetail-Ratetl">
							<img :src="'http://www.sweetour.com'+item.Face" alt="">
							<p>{{item.NickName}}</p>
						</span>
						<span class="visadetail-Ratetr">
							<label for="" class="visadetail-Ratetr_label">
								<van-rate v-model="item.StarLevel" color="#fbb03b" size="14px" />
								<p>{{item.Score}}分</p>
							</label>
							<p>{{item.Rectime}}</p>
						</span>
					</div>
					<div class="visadetail-Rateb">
						<img src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/sweetmini/dianping_arrow.png"
							alt="">
						<label for="">{{item.Mark_01}}</label>
					</div>
				</li>
			</ul>
		</van-list>
	</div>
</template>

<script>
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'comments',
		components: {
			BackTo
		},
		data() {
			return {
				loading: false,
				finished: false,
				page: 1,
				data_product_array: []
			}
		},
		computed: {

		},
		mounted() {
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.getList()
				}, 500);
			},
			getList() {
				var mydata = {
					"pid": this.$route.query.pid,
					"pageIndex": this.page,
					"productType": this.$route.query.type
				}
				this.$get(
					this.$apiWebsiteSweet + '/api/GetMpCommentsList', mydata
				).then(res => {
					this.data_product_array = this.data_product_array.concat(res.data)
					if (res.data.length < 10) {
						this.finished = true;
					}
				})
			},
		}
	}
</script>

<style scoped>
	.visadetail-Ratetl img {
		width: 72px;
		height: 72px;
		border-radius: 36px;
		margin-right: 14px;
		border: 6px solid #eeeeee;
	}

	.visadetail-Rate li {
		width: 100%;
		padding: 30px 32px;
		box-sizing: border-box;
		border-bottom: 20px solid #eeeeee;
	}

	.visadetail-Ratet {
		display: flex;
		justify-content: space-between;
	}

	.visadetail-Rateb label {
		color: #333333;
		font-size: 24px;
		padding: 20px;
		background-color: #f2f2f2;
		border-radius: 6px;
		display: block;
	}

	.visadetail-Rateb img {
		margin-left: 24px;
		width: 24px;
	}

	.visadetail-Ratetr {
		font-size: 22px;
		color: #999999;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.visadetail-Ratetr label {
		display: flex;
		align-items: center;
	}

	.visadetail-Ratetr_label p {
		padding-left: 19px;
		color: #ff6d00;
	}

	.visadetail-Ratetl {
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #000;
		/* padding-bottom: 20px; */
		height: 72px;
		justify-content: space-between;
	}
</style>
